// @flow
import React, { useState, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import type { User } from '../../../types';
import Spinner from '../../ui/Spinner';
import UserManagement from './UserManagement';

export type Props = $ReadOnly<{
    list: $ReadOnlyArray<string>,
    entities: $ReadOnly<{[uid: string]: User}>,
    status: $ReadOnly<{
        fetched: boolean,
        isLoading: boolean
    }>,

    createUser: (user: User) => void,
    updateUser: (user: User) => void
}>;

function Users({ list, entities, status, createUser, updateUser }: Props) {
    const [type, setType] = useState('drivers');

    const drivers = useMemo(() => (list ? list.filter(userId => !entities[userId].isAdmin) : []), [list, entities]);
    const admins = useMemo(() => (list ? list.filter(userId => entities[userId].isAdmin === true): []), [list, entities]);

    const handleChange = (e, value) => setType(value);

    return (
        <div>
            <Tabs
                value={type}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="Zone list type"
            >
                <Tab
                    label={<FormattedMessage
                        id="options.users.drivers"
                        defaultMessage="Drivers"
                    />}
                    value="drivers"
                />
                <Tab
                    label={<FormattedMessage
                        id="options.users.admins"
                        defaultMessage="Administrators"
                    />}
                    value="admins"
                />
            </Tabs>

            <Spinner isLoading={!status.fetched || status.isLoading}>
                {status.fetched &&
                    <React.Fragment>
                        {type === 'drivers' && <UserManagement userType="driver" users={drivers} createUser={createUser} updateUser={updateUser} />}
                        {type === 'admins' && <UserManagement userType="admin" users={admins} createUser={createUser} updateUser={updateUser} />}
                    </React.Fragment>
                }
            </Spinner>
        </div>
    );
}

export default Users;